.tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.1875rem;
  padding: var(--tag-py) var(--tag-px);
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface);
  color: var(--text-secondary);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-medium);
  font-size: var(--tag-font-size);
  line-height: var(--tag-line-height);
  white-space: nowrap;
  vertical-align: middle;
}

/* Sizes ------------------------------------------------------------------- */
.sm {
  --tag-py: 0.1875rem;
  --tag-px: 0.5rem;
  --tag-font-size: var(--text-xs-font-size);
  --tag-line-height: var(--text-xs-line-height);
  --tag-box: 0.875rem;
  --tag-box-radius: 0.25rem;
  --tag-glyph: 0.625rem;
}
.md {
  --tag-py: 0.125rem;
  --tag-px: 0.5625rem;
  --tag-font-size: var(--text-sm-font-size);
  --tag-line-height: var(--text-sm-line-height);
  --tag-box: 1rem;
  --tag-box-radius: 0.25rem;
  --tag-glyph: 0.75rem;
}
.lg {
  --tag-py: 0.25rem;
  --tag-px: 0.625rem;
  --tag-font-size: var(--text-sm-font-size);
  --tag-line-height: var(--text-sm-line-height);
  --tag-box: 1.125rem;
  --tag-box-radius: 0.375rem;
  --tag-glyph: 0.875rem;
}

/* Trim padding on the side carrying an affordance. */
.has-checkbox {
  padding-inline-start: calc(var(--tag-px) - 0.3125rem);
}
.has-count {
  padding-inline-end: calc(var(--tag-px) - 0.375rem);
}
.has-close {
  padding-inline-end: calc(var(--tag-px) - 0.3125rem);
}

.disabled {
  /* Disabled text is still content, so retain the WCAG 2.2 AA 4.5:1 contrast floor. */
  color: var(--text-tertiary);
  cursor: not-allowed;
}
.tag.has-checkbox:not(.disabled) {
  cursor: pointer;
}

/* Content ----------------------------------------------------------------- */
.content {
  display: inline-flex;
  align-items: center;
  gap: 0.3125rem;
}
.text {
  white-space: nowrap;
}
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: var(--tag-glyph);
  line-height: 0;
}

/* Trailing count badge ---------------------------------------------------- */
.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 1.25rem;
  padding-inline: 0.3125rem;
  border-radius: 0.1875rem;
  background: var(--surface-tertiary);
  color: var(--text-secondary);
  font-size: var(--text-xs-font-size);
  line-height: var(--text-xs-line-height);
}

/* Dismiss button ---------------------------------------------------------- */
.close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.125rem;
  border: 0;
  border-radius: 0.1875rem;
  background: transparent;
  color: var(--text-disabled);
  font-size: 0.75rem;
  line-height: 0;
  cursor: pointer;
}
.close:hover:not(:disabled) {
  color: var(--text-secondary);
}
.close:disabled {
  cursor: not-allowed;
}
.close:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 1px;
  box-shadow: var(--focus-ring);
}

/* Checkbox ---------------------------------------------------------------- */
.input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.box {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--tag-box);
  height: var(--tag-box);
  border: 1px solid var(--border);
  border-radius: var(--tag-box-radius);
  background: var(--surface);
  font-size: var(--tag-glyph);
  color: var(--fg-on-solid);
}
.check {
  display: inline-flex;
  visibility: hidden;
  line-height: 0;
}
.input:checked + .box {
  background: var(--brand-solid);
  border-color: var(--brand-solid);
}
.input:checked + .box .check {
  visibility: visible;
}
.input:focus-visible + .box {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow: var(--focus-ring);
}
.input:disabled + .box {
  background: var(--surface-tertiary);
  border-color: var(--border);
}
